import { render } from "./NewStudentRow.vue?vue&type=template&id=3476a61e&scoped=true"
import script from "./NewStudentRow.vue?vue&type=script&lang=js"
export * from "./NewStudentRow.vue?vue&type=script&lang=js"

import "./NewStudentRow.vue?vue&type=style&index=0&id=3476a61e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3476a61e"]])

export default __exports__